"use client"

import { Component } from "react"
import redux from "../../common/Redux"
import Header from "../../components/Header"
import Toast from "../../components/Toast"
import API, { URL_PATH, base_url } from "../../services/API"
import rz from "../../assets/razorpay.jpg"
import st from "../../assets/stripe.jpg"
import pp from "../../assets/paypal.png"
import cf from "../../assets/cashfree.png"
import eb from "../../assets/eb.png"
import PhonepeImage  from "../../assets/Phonepe.jpg"
import cc from "../../assets/cc.png"
import PaytmImage from "../../assets/Paytm.png"
import routes from "../../routes/URL"

import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  TextField,
  Grid,
  Button,
  Box,
  Avatar,
  Divider,
  FormControlLabel,
  Switch,
  CircularProgress,
  Tooltip,
  IconButton,
  Collapse
} from "@mui/material"
import {
  Info as InfoIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  ExpandMore,
  ExpandLess
} from "@mui/icons-material"

// Gateway Icons
const RazorpayIcon = () => <img src={rz} alt="Razorpay" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
const StripeIcon = () => <img src={st} alt="Stripe" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
const PaypalIcon = () => <img src={pp} alt="PayPal" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
const CashfreeIcon = () => <img src={cf} alt="Cashfree" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
const EasebuzzIcon = () => <img src={eb} alt="Easebuzz" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
const PhonepeIcon  = () => <img src={PhonepeImage } alt="PhonepeImage " style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
const CcIcon  = () => <img src={cc } alt="cc " style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
const PaytmIcon  = () => <img src={PaytmImage} alt="PaytmImage" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />

class IntegrationListScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      version: 1,
      loading: true,
      error: null,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
      easebuzzExpanded: false,
      onlinePaymentEnabled: false,
      bankDetails: {
        bank_acc_holder_name: "",
        bank_name: "",
        bank_branch_name: "",
        bank_account_number: "",
        ifsc_code: "",
        currency: "INR",
      },
      bankDetailsFilled: false,
      configLoading: true,
      gateways: [],
      gatewayCredentials: {},
      gatewayStatus: {},
      existingGatewayData: {},
      expandedGateway: null
    }
  }

  componentDidMount() {
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug)
    if (!hotel) {
      this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''))
      return
    }
    this.fetchHotelProfile()
    this.fetchConfig()
    this.fetchActiveGateways()
  }

  fetchActiveGateways = async () => {
    try {
      const gatewaysResponse = await API(this, "get", URL_PATH.get_active_gateways)
      const gateways = gatewaysResponse || []

      const credentialsResponse = await API(this, "get", URL_PATH.get_gateways_credentials)
      const existingCredentials = credentialsResponse?.data || []

      const existingGatewayData = existingCredentials.reduce((acc, curr) => {
        acc[curr.payment_gateway_id] = curr
        return acc
      }, {})

      const credentials = {}
      const gatewayStatus = {}

      gateways.forEach((gateway) => {
        const existingGateway = existingGatewayData[gateway.id]

        switch (gateway.id) {
          case 1: // Razorpay
            credentials[gateway.name] = existingGateway?.credentials || { key: "", secret: "" }
            break
          case 2: // Stripe
            credentials[gateway.name] = existingGateway?.credentials || { key: "", secret: "" }
            break
          case 3: // PayPal
            credentials[gateway.name] = existingGateway?.credentials || { client_id: "", secret: "" }
            break
          case 4: // Cashfree
            credentials[gateway.name] = existingGateway?.credentials || { key: "", secret: "" }
            break
          case 5: // Easebuzz
            credentials[gateway.name] = existingGateway?.credentials || { key: "", salt: "" }
            break
          default:
            credentials[gateway.name] = existingGateway?.credentials || {}
        }
        gatewayStatus[gateway.id] = existingGateway ? existingGateway.payment_mode : false
      })

      this.setState({
        gateways: gateways,
        gatewayCredentials: credentials,
        gatewayStatus: gatewayStatus,
        existingGatewayData: existingGatewayData,
        loading: false,
      })
    } catch (error) {
      console.error("Error fetching gateways:", error)
      this.showToast("Failed to fetch payment gateways", "error")
      this.setState({ loading: false, error: error })
    }
  }

  handleGatewayToggle = async (gatewayId, isEnabled) => {
    const gateway = this.state.gateways.find((g) => g.id === gatewayId)
    if (!gateway) {
      this.showToast("Gateway not found", "error")
      return
    }

    if (isEnabled && !this.areCredentialsValid(gateway)) {
      this.showToast(`Please fill all required credentials for ${gateway.name} first`, "error")
      return
    }

    try {
      this.setState((prevState) => ({
        gatewayStatus: {
          ...prevState.gatewayStatus,
          [gatewayId]: isEnabled,
        },
      }))

      const existingData = this.state.existingGatewayData[gatewayId]
      const currentCredentials = this.state.gatewayCredentials[gateway.name] || {}

      const payload = {
        payment_gateway_id: gatewayId,
        credentials: currentCredentials,
        webhook_url: `${base_url}/order/payment-webhook`,
        payment_mode: isEnabled,
      }

      let response
      if (existingData && existingData.id) {
        response = await API(this, "post", URL_PATH.update_gateways_credentials(existingData.id), payload)
      } else {
        response = await API(this, "post", URL_PATH.add_gateways_credentials, payload)
      }

      if (response) {
        this.showToast(`${gateway.name} ${isEnabled ? "enabled" : "disabled"} successfully`, "success")
        if (!existingData || !existingData.id) {
          this.setState((prevState) => ({
            existingGatewayData: {
              ...prevState.existingGatewayData,
              [gatewayId]: response.data,
            },
          }))
        }
      } else {
        this.setState((prevState) => ({
          gatewayStatus: {
            ...prevState.gatewayStatus,
            [gatewayId]: !isEnabled,
          },
        }))
        this.showToast(response.message || `Failed to update ${gateway.name} status`, "error")
      }
    } catch (error) {
      console.error("Error toggling gateway:", error)
      this.setState((prevState) => ({
        gatewayStatus: {
          ...prevState.gatewayStatus,
          [gatewayId]: !isEnabled,
        },
      }))
      this.showToast("An error occurred while updating gateway status", "error")
    }
  }

  fetchConfig = async () => {
    const response = await API(this, "get", URL_PATH.GET_PREFERENCES)
    const { status, message, data } = response
    if (status === "success") {
      const { hotelConfig } = data
      this.setState({
        onlinePaymentEnabled: hotelConfig.online_payment,
        configLoading: false,
      })
    } else {
      this.setState({ configLoading: false, error: message })
    }
  }

  fetchHotelProfile = async () => {
    const hotelId = this.props.selectedHotelId?.id
    if (!hotelId) {
      console.warn("No selectedHotelId found, skipping hotel profile fetch.")
      this.setState({ loading: false })
      return
    }

    const { status, message, data } = await API(this, "get", URL_PATH.hotelProfile(hotelId))
    if (status == "success") {
      const bankDetailsFilled =
        data.bank_acc_holder_name && data.bank_name && data.bank_account_number && data.ifsc_code
      this.setState({
        bankDetails: {
          bank_acc_holder_name: data.bank_acc_holder_name || "",
          bank_name: data.bank_name || "",
          bank_branch_name: data.bank_branch_name || "",
          bank_account_number: data.bank_account_number || "",
          ifsc_code: data.ifsc_code || "",
          currency: data.currency || "INR",
        },
        bankDetailsFilled,
        mounted: true,
      })
    } else {
      this.setState({ error: message })
    }
  }

  handleToastClose = () => {
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  toggleGatewayExpansion = (gatewayId) => {
    this.setState(prevState => ({
      expandedGateway: prevState.expandedGateway === gatewayId ? null : gatewayId
    }))
  }

  handleCredentialChange = (gatewayName, field, value) => {
    this.setState(prevState => ({
      gatewayCredentials: {
        ...prevState.gatewayCredentials,
        [gatewayName]: {
          ...prevState.gatewayCredentials[gatewayName],
          [field]: value
        }
      }
    }))
  }

  areCredentialsValid = (gateway) => {
    const { gatewayCredentials } = this.state
    const credentials = gatewayCredentials[gateway.name] || {}

    switch (gateway.id) {
      case 1: // Razorpay
      case 2: // Stripe
      case 4: // Cashfree
        return credentials.key && credentials.secret
      case 3: // PayPal
        return credentials.client_id && credentials.secret
      case 5: // Easebuzz
        return credentials.key && credentials.salt
      default:
        return false
    }
  }

  saveGatewayCredentials = async (gatewayId) => {
    try {
      const { gatewayCredentials, gateways, existingGatewayData, gatewayStatus } = this.state
      const gateway = gateways.find((g) => g.id === gatewayId)
      if (!gateway) {
        this.showToast(`Gateway not found`, "error")
        return
      }
      const credentials = gatewayCredentials[gateway.name] || {}

      let isValid = true
      switch (gateway.id) {
        case 1:
        case 2:
        case 4:
          isValid = credentials.key && credentials.secret
          break
        case 3:
          isValid = credentials.client_id && credentials.secret
          break
        case 5:
          isValid = credentials.key && credentials.salt
          break
        default:
          isValid = false
      }
      if (!isValid) {
        this.showToast(`Please fill all required fields for ${gateway.name}`, "error")
        return
      }

      const existingData = existingGatewayData[gatewayId]
      const payload = {
        payment_gateway_id: gateway.id,
        credentials: credentials,
        webhook_url: `${base_url}/order/payment-webhook`,
        payment_mode: gatewayStatus[gateway.id],
      }

      let response
      if (existingData && existingData.id) {
        response = await API(this, "post", URL_PATH.update_gateways_credentials(existingData.id), payload)
      } else {
        response = await API(this, "post", URL_PATH.add_gateways_credentials, payload)
      }

      if (response.status === "success") {
        this.showToast(`${gateway.name} credentials saved successfully`, "success")
        if (!existingData || !existingData.id) {
          this.setState((prevState) => ({
            existingGatewayData: {
              ...prevState.existingGatewayData,
              [gatewayId]: response.data,
            },
          }))
        }
      } else {
        this.showToast(response.message || `Failed to save ${gateway.name} credentials`, "error")
      }
    } catch (error) {
      console.error(`Error saving credentials:`, error)
      this.showToast(`An error occurred while saving credentials`, "error")
    }
  }

  getGatewayIcon = (gatewayId) => {
    switch (gatewayId) {
      case 1:
        return <RazorpayIcon />
      case 2:
        return <StripeIcon />
      case 3:
        return <PaypalIcon />
      case 4:
        return <CashfreeIcon />
      case 5:
        return <EasebuzzIcon />
         case 6: 
      return <PhonepeIcon />
       case 7: 
      return <CcIcon />
       case 8: 
      return <PaytmIcon />
      default:
        return null
    }
  }

  getGatewayDescription = (gatewayId, gatewayName) => {
    switch (gatewayId) {
      case 1:
        return "Accept payments via UPI, Cards, Net Banking, and Wallets"
      case 2:
        return "Global payment processing with advanced fraud protection"
      case 3:
        return "Trusted worldwide payment solution for online transactions"
      case 4:
        return "Comprehensive payment gateway for Indian businesses"
      case 5:
        return "Comprehensive payment gateway for Indian businesses"
      default:
        return `Securely accept online payments via ${gatewayName}`
    }
  }

 renderGatewayFields(gateway) {
    const { gatewayCredentials } = this.state
    const credentials = gatewayCredentials[gateway.name] || {}

    const gatewayColors = {
      1: { primary: '#3395FF', secondary: '#E6F2FF' },
      2: { primary: '#635BFF', secondary: '#F0EFFF' },
      3: { primary: '#0070BA', secondary: '#E6F0FA' },
      4: { primary: '#00D4AA', secondary: '#E6F9F5' },
      5: { primary: '#FFC857', secondary: '#FFF8E6' }
    }

    const { primary } = gatewayColors[gateway.id] || { primary: '#FFC857' }

    return (
      <Box
        sx={{
          backgroundColor: "#041A29",
          p: 1,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              required
              label={gateway.id === 3 ? "Client ID" : "Key ID"}
              name="key"
              value={credentials.key || credentials.client_id || ""}
              onChange={(e) =>
                this.handleCredentialChange(gateway.name, gateway.id === 3 ? "client_id" : "key", e.target.value)
              }
              variant="outlined"
              placeholder={
                gateway.id === 1
                  ? "rzp_test_xxxxxxxxxx"
                  : gateway.id === 2
                    ? "pk_test_xxxxxxxxxx"
                    : gateway.id === 3
                      ? "Your PayPal Client ID"
                      : gateway.id === 4
                        ? "Your Cashfree App ID"
                        : "Your Easebuzz Key"
              }
              // sx={{
              //   '& .MuiOutlinedInput-root': {
              //     backgroundColor: '#041A29',
              //     // '& fieldset': { borderColor: 'divider' },
              //     // '&.Mui-focused fieldset': { borderColor: primary },
              //   },
              //   // '& .MuiInputLabel-root.Mui-focused': {
              //   //   color: primary,
              //   // }
              // }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              required
              label={gateway.id === 5 ? "Salt" : "Secret Key"}
              name="secret"
              value={credentials.secret || credentials.salt || ""}
              onChange={(e) =>
                this.handleCredentialChange(gateway.name, gateway.id === 5 ? "salt" : "secret", e.target.value)
              }
              variant="outlined"
              type="password"
              placeholder={
                gateway.id === 1
                  ? "Your secret key"
                  : gateway.id === 2
                    ? "sk_test_xxxxxxxxxx"
                    : gateway.id === 3
                      ? "Your PayPal Secret"
                      : gateway.id === 4
                        ? "Your Cashfree Secret Key"
                        : "Your Easebuzz Salt"
              }
              // sx={{
              //   '& .MuiOutlinedInput-root': {
              //     backgroundColor: '#041A29',
              //     '& fieldset': { borderColor: 'divider' },
              //     '&.Mui-focused fieldset': { borderColor: primary },
              //   },
              //   '& .MuiInputLabel-root.Mui-focused': {
              //     color: primary,
              //   }
              // }}
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          {/* <Button
            variant="outlined"
            sx={{
              color: 'text.secondary',
              backgroundColor: "#BB0A21",
              '&:hover': {
                backgroundColor: "#BB0A21",
              }
            }}
          >
            Cancel
          </Button> */}
          <Button
            variant="contained"
            onClick={() => this.saveGatewayCredentials(gateway.id)}
            sx={{
              backgroundColor: "#FFC857",
              '&:hover': {
                backgroundColor: "#FFC857",
              },
              fontWeight: 600,
            }}
          >
            Save Credentials
          </Button>
        </Box>
      </Box>
    )
  }

  renderGatewayCard(gateway) {
    const { gatewayStatus } = this.state
    const isActive = gatewayStatus[gateway.id]
    const hasValidCredentials = this.areCredentialsValid(gateway)

    const gatewayColors = {
      1: '#3395FF',
      2: '#635BFF',
      3: '#0070BA',
      4: '#00D4AA',
      5: '#FFC857'
    }

    const color = gatewayColors[gateway.id] || '#FFC857'

    return (
      <Grid item xs={12} sm={6} md={4} key={gateway.id}>
        <Card sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          border: '1px solid #FFC857',
          backgroundColor: "#041A29",
          backgroundImage: 'none',
        }}>
          <CardHeader
            avatar={
              <Avatar sx={{ 
                width: 48, 
                height: 48,
                backgroundColor: 'transparent',
                borderRadius: '8px'
              }}>
                {this.getGatewayIcon(gateway.id)}
              </Avatar>
            }
            title={
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {gateway.name.charAt(0).toUpperCase() + gateway.name.slice(1)}
              </Typography>
            }
            // subheader={
            //   <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            //     {isActive ? 'Active' : 'Inactive'} • {hasValidCredentials ? 'Configured' : 'Not configured'}
            //   </Typography>
            // }
            action={
              <FormControlLabel
                control={
                  <Switch
                    checked={isActive}
                    onChange={(e) => this.handleGatewayToggle(gateway.id, e.target.checked)}
                    color="primary"
                    disabled={!hasValidCredentials}
                    // sx={{
                    //   '& .MuiSwitch-switchBase.Mui-checked': {
                    //     color: color,
                    //   },
                    //   '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    //     backgroundColor: color,
                    //   },
                    // }}
                  />
                }
                label=""
                labelPlacement="start"
              />
            }
            sx={{
              pb: 1,
              borderBottom: '1px solid',
              borderColor: 'divider'
            }}
          />
          
          <CardContent sx={{ flexGrow: 1 }}>
            {this.renderGatewayFields(gateway)}
          </CardContent>
        </Card>
      </Grid>
    )
  }

  render() {
    const { toast, loading, gateways } = this.state

    // if (loading) {
    //   return (
    //     <Box sx={{
    //       display: 'flex',
    //       justifyContent: 'center',
    //       alignItems: 'center',
    //       height: '100vh',
    //       backgroundColor: 'background.default'
    //     }}>
    //       <Box sx={{ textAlign: 'center' }}>
    //         <CircularProgress size={60} thickness={4} sx={{ color: 'primary.main', mb: 3 }} />
    //         <Typography variant="h6" color="text.primary">
    //           Loading Payment Gateways...
    //         </Typography>
    //         <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
    //           Please wait while we load your integration settings
    //         </Typography>
    //       </Box>
    //     </Box>
    //   )
    // }

    return (
      <Box sx={{ 
        backgroundColor: "#02111B",
        minHeight: '100vh',
        p: 3
      }}>
        <Header title="Integrations" 
          subtitle="Connect and manage your payment gateways" 
          sx={{ mb: 4 }} 
        />
        
        <Box sx={{ 
          maxWidth: 1600, 
          mx: 'auto',
          mb: 6
        }}>
        

          <Grid container spacing={3}>
            {gateways.map(gateway => this.renderGatewayCard(gateway))}
          </Grid>
        </Box>

        <Toast
          open={toast.open}
          message={toast.message}
          severity={toast.severity}
          handleClose={this.handleToastClose}
        />
      </Box>
    )
  }
}

export default redux(IntegrationListScreen)